import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import ButtonOptionGroup from '../../component/ButtonOptions/ButtonOption';
import { pdf, Page, Text, Document, StyleSheet } from '@react-pdf/renderer';
import Modal from 'react-modal';
// import InvoicePDF from './InvoiceSales';

const DetailJournal = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [error, setError] = useState(null);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const [detailData, setDetailData] = useState(null);
    const [itemData, setItemData] = useState([]);
    // const [paymentData, setPaymentData] = useState([]);
    const [taxData, setTaxData] = useState([]);
    const [actions, setActions] = useState([
        { value: 'edit', label: 'Ubah' },
        { value: 'faktur', label: 'Cetak Faktur' },
    ]);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_JOURNAL = "api/erpppsu/journal";

    const fetchData = async (url) => {
        try {
            const response = await axios.get(url);
            return response.data;
        } catch (err) {
            setError("Gagal memuat data. Silakan coba lagi.");
            console.error(err);
            return null;
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_JOURNAL}/detail?id=${id}`).then((data) => {
                setDetailData(data)
            });

            fetchData(`${BASE_URL}${PATH_JOURNAL}/items?id=${id}`).then((data) => {
                setItemData(data)
            });
        }
    }, [id]);

    useEffect(() => {
        if (detailData) {
            if (detailData.status == 'PAID') {
                setActions([
                    { value: 'edit', label: 'Ubah' },
                    { value: 'invoice', label: 'Cetak Invoice' },
                ])
            } else if (detailData.status == 'CLOSED') {
                setActions([
                    { value: 'invoice', label: 'Cetak Invoice' },
                ])
            }
        }
    }, [detailData]);

    const handlePreview = async () => {
        // const blob = await pdf(<InvoicePDF detailData={detailData} itemData={itemData} logoUrl={`${BASE_URL}/upload/logo/1734138205_logo.png`}/>).toBlob();
        // const url = URL.createObjectURL(blob);
        // setPdfPreviewUrl(url);
        // setIsModalOpen(true);
    };

    return (
        <div className="p-6 bg-gray-50 font-sans">
            <h1 className="text-2xl font-bold mb-6">Journal Entry</h1>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div>
                    <p className="font-semibold">Tgl. Transaksi:</p>
                    <p>{detailData?.date}</p>
                </div>
                <div>
                    <p className="font-semibold">No Transaksi:</p>
                    <p>{detailData?.no_transaction}</p>
                </div>
                <div>
                    <p className="font-semibold">Tag:</p>
                    <p>{detailData?.tags}</p>
                </div>
            </div>

            <div className="relative overflow-x-auto">
                <table className="w-full text-left border-collapse">

                    <thead>
                        <tr className="bg-gray-100 border-b">
                            <th className="p-2">Nomor Akun</th>
                            <th className="p-2">Akun</th>
                            <th className="p-2">Deskripsi</th>
                            <th className="p-2 text-right">Debit</th>
                            <th className="p-2 text-right">Kredit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemData?.map((item, index) => (
                            <tr
                                key={index}
                                className="border-b hover:bg-gray-50 transition-colors"
                            >
                                <td className="p-2">{item?.account_name}</td>
                                <td className="p-2">{item?.account_name}</td>
                                <td className="p-2">{item?.description}</td>
                                <td className="p-2 text-right">{item?.debit}</td>
                                <td className="p-2 text-right">
                                    Rp {parseFloat(item?.credit).toLocaleString("id-ID")}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="flex flex-col items-end mt-6">
                {/* <p className="text-right">
                    <span className="font-semibold">Subtotal:</span> Rp{" "}
                    {parseFloat(detailData?.subtotal_amount).toLocaleString("id-ID")}
                </p> */}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4 my-6">
                {/* <div>
                    <p>
                        <span className="font-semibold">Pesan:</span> {detailData?.notes}
                    </p>
                    <p>
                        <span className="font-semibold">Memo:</span> {detailData?.memo}
                    </p>
                </div> */}
            </div>

            <footer className="mt-6 text-sm text-gray-500">
                {/* Terakhir diubah oleh {detailData?.updated_by} pada{" "}
                {detailData?.updated_at}. */}
            </footer>

            <div className='flex flex-row mt-6'>
                <ButtonOptionGroup
                    position='popup-position'
                    label={"Tindakan"}
                    options={actions}
                    onChange={(value) => {
                        if (value == 'faktur') {
                            handlePreview();
                        } else {
                            navigate(`/activity-erpppsu/journal/${value}/${detailData.id}`);
                        }
                    }}
                />
            </div>

            <Modal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                contentLabel="PDF Preview Modal"
                style={{
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        height: '80%',
                    },
                    overlay: { zIndex: 1000, backgroundColor: 'rgba(0, 0, 0, 0.5)' },
                }}
            >
                <div className="modal-header">
                    <h4>Invoice Preview</h4>
                    <button className="close-button" onClick={() => setIsModalOpen(false)}>
                        &times;
                    </button>
                </div>
                <iframe
                    src={pdfPreviewUrl}
                    title="PDF Preview"
                    width="100%"
                    height="100%"
                    className="border border-gray-300 rounded"
                ></iframe>
                <div className="text-center mt-4">
                    <a
                        href={pdfPreviewUrl}
                        download="Invoice.pdf"
                        className="px-4 py-2 bg-green-500 text-white rounded"
                    >
                        Download PDF
                    </a>
                </div>
            </Modal>
        </div>
    );
}

export default DetailJournal;
